<script setup lang="ts">
import { useNotifications } from '../../composables/useNotifications'

const { notifications, removeNotification } = useNotifications()

const getAlertColor = (type: string) => {
  const colorMap: Record<string, string> = {
    success: 'success',
    error: 'danger',
    info: 'info',
    warning: 'warning',
  }
  return colorMap[type] || 'info'
}

const getIcon = (type: string) => {
  const iconMap: Record<string, string> = {
    success: 'check_circle',
    error: 'error',
    info: 'info',
    warning: 'warning',
  }
  return iconMap[type] || 'info'
}
</script>

<template>
  <Teleport to="body">
    <div class="notification-container fixed top-4 right-4 z-[9999] flex flex-col gap-2 max-w-md">
      <TransitionGroup name="notification" tag="div">
        <VaCard
          v-for="notification in notifications"
          :key="notification.id"
          class="notification-item shadow-lg"
          :color="getAlertColor(notification.type)"
        >
          <VaCardContent class="flex items-center gap-3 p-4">
            <VaIcon
              :name="getIcon(notification.type)"
              :color="getAlertColor(notification.type)"
              size="small"
              class="flex-shrink-0"
            />
            <p class="flex-1 text-sm">{{ notification.message }}</p>
            <VaButton
              preset="plain"
              icon="close"
              size="small"
              class="flex-shrink-0"
              @click="removeNotification(notification.id)"
            />
          </VaCardContent>
        </VaCard>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style scoped>
.notification-container {
  pointer-events: none;
  z-index: 9999 !important;
  position: fixed;
}

.notification-item {
  pointer-events: auto;
}

.notification-enter-active,
.notification-leave-active {
  transition: all 0.3s ease;
}

.notification-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.notification-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.notification-move {
  transition: transform 0.3s ease;
}
</style>
